import { Typography } from "@mui/material";

const Empty = ({ children = "Not Set" }) => (
  <Typography variant="body2" component="span" color="text.secondary">
    {children}
  </Typography>
);

export default Empty;
